import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import cn from 'classnames'
import './button.scss'

class Button extends PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    unavailableLabel: PropTypes.string,
    isAvailable: PropTypes.bool,
    filterType: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    isApplied: PropTypes.bool.isRequired,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: null,
    unavailableLabel: 'See available dates',
    isAvailable: false,
  }

  getLabel = () => {
    const {
      label,
      isAvailable,
      unavailableLabel,
      filterType,
    } = this.props

    if (filterType === 'availableDates') {
      if (isAvailable) {
        return parse(label)
      }
      return unavailableLabel
    }
    return parse(label)
  }

  handleClick = (event) => {
    event.stopPropagation()
    const { onClick, filterType } = this.props
    const isAvailableDates = filterType === 'availableDates'
    onClick(isAvailableDates ? 'dates' : filterType, event, isAvailableDates)
  }

  render() {
    const {
      isActive,
      isApplied,
      className,
      isAvailable,
      filterType,
    } = this.props

    return (
      <div
        className={cn('search-filter-button', filterType, className, {
          active: isActive,
          'reserve-book-btn': isAvailable,
          applied: isApplied,
        })}
        onClick={this.handleClick}
        role="presentation"
      >
        <div className={cn('search-filter-button__label', isActive && 'active', isApplied && 'applied')}>
          {this.getLabel()}
        </div>
      </div>
    )
  }
}


export default Button
